module.exports = __webpack_public_path__ + "static/media/br-ms.45158285.svg";